import { render, staticRenderFns } from "./ExchangeUpload.vue?vue&type=template&id=a5cb2900&"
import script from "./ExchangeUpload.vue?vue&type=script&lang=js&"
export * from "./ExchangeUpload.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeUpload.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports